import { Link, useLocation } from "react-router-dom";
import { Collapsible } from "radix-ui";

import {
  LayoutDashboard,
  Target,
  BarChart3,
  ChevronRight,
} from "lucide-react";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "@/components/ui/sidebar";

const NAV_GROUPS = [
  {
    title: "Dashboards",
    icon: LayoutDashboard,
    items: [
      { title: "Website Dashboard", url: "/" },
      { title: "Manual Dashboard", url: "/manual" },
    ],
  },
  {
    title: "Leads",
    icon: Target,
    items: [
      { title: "Website Leads", url: "/leads" },
      { title: "Manual Leads", url: "/manual-leads" },
    ],
  },
] as const;

const NAV_STANDALONE = [
  { title: "Visitors", url: "/visitors", icon: BarChart3 },
] as const;

export function NavMain() {
  const { pathname } = useLocation();

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Platform</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          {NAV_GROUPS.map((group) => (
            <Collapsible.Root
              key={group.title}
              asChild
              defaultOpen
              className="group/collapsible"
            >
              <SidebarMenuItem>
                <Collapsible.Trigger asChild>
                  <SidebarMenuButton tooltip={group.title}>
                    <group.icon />
                    <span>{group.title}</span>
                    <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                  </SidebarMenuButton>
                </Collapsible.Trigger>
                <Collapsible.Content className="overflow-hidden data-[state=closed]:animate-[collapsible-up_200ms_ease-out] data-[state=open]:animate-[collapsible-down_200ms_ease-out]">
                  <SidebarMenuSub>
                    {group.items.map((item) => (
                      <SidebarMenuSubItem key={item.title}>
                        <SidebarMenuSubButton
                          asChild
                          isActive={pathname === item.url}
                        >
                          <Link to={item.url}>
                            <span>{item.title}</span>
                          </Link>
                        </SidebarMenuSubButton>
                      </SidebarMenuSubItem>
                    ))}
                  </SidebarMenuSub>
                </Collapsible.Content>
              </SidebarMenuItem>
            </Collapsible.Root>
          ))}

          {NAV_STANDALONE.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton
                asChild
                tooltip={item.title}
                isActive={pathname === item.url}
              >
                <Link to={item.url}>
                  <item.icon />
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
